import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import BodyBase from '../body_base'

const Callout = ({ children, component, variant, colour }) => {
  return (
    <BodyBase
      colour={colour}
      component={component}
      componentStyles={styles}
      variant={variant}
    >
      {children}
    </BodyBase>
  )
}

Callout.defaultProps = {
  component: 'p'
}

Callout.propTypes = {
  component: PropTypes.string
}

export default Callout
